/* tslint:disable */
/* eslint-disable */
/**
 * channels-com
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
  Card,
  CardFromJSON,
  CardFromJSONTyped,
  CardToJSON,
  ChannelDenomination,
  ChannelDenominationFromJSON,
  ChannelDenominationFromJSONTyped,
  ChannelDenominationToJSON,
} from './';

/**
 *
 * @export
 * @interface ChannelCardWithDenoms
 */
export interface ChannelCardWithDenoms {
  /**
   *
   * @type {number}
   * @memberof ChannelCardWithDenoms
   */
  id: number;
  /**
   *
   * @type {number}
   * @memberof ChannelCardWithDenoms
   */
  channelId: number;
  /**
   *
   * @type {Card}
   * @memberof ChannelCardWithDenoms
   */
  card: Card;
  /**
   *
   * @type {boolean}
   * @memberof ChannelCardWithDenoms
   */
  isActive: boolean;
  /**
   *
   * @type {Date}
   * @memberof ChannelCardWithDenoms
   */
  createdAt: Date;
  /**
   *
   * @type {Date}
   * @memberof ChannelCardWithDenoms
   */
  updatedAt: Date;
  /**
   *
   * @type {number}
   * @memberof ChannelCardWithDenoms
   */
  listingOrder?: number;
  /**
   *
   * @type {number}
   * @memberof ChannelCardWithDenoms
   */
  beginPrice: number;
  /**
   *
   * @type {string}
   * @memberof ChannelCardWithDenoms
   */
  image: string;
  /**
   *
   * @type {Array<ChannelDenomination>}
   * @memberof ChannelCardWithDenoms
   */
  channelDenominations: Array<ChannelDenomination>;
}

export function ChannelCardWithDenomsFromJSON(
  json: any
): ChannelCardWithDenoms {
  return ChannelCardWithDenomsFromJSONTyped(json, false);
}

export function ChannelCardWithDenomsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ChannelCardWithDenoms {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json['id'],
    channelId: json['channel_id'],
    card: CardFromJSON(json['card']),
    isActive: json['is_active'],
    createdAt: new Date(json['created_at']),
    updatedAt: new Date(json['updated_at']),
    listingOrder: !exists(json, 'listing_order')
      ? undefined
      : json['listing_order'],
    beginPrice: json['begin_price'],
    image: json['image'],
    channelDenominations: (json['channel_denominations'] as Array<any>).map(
      ChannelDenominationFromJSON
    ),
  };
}

export function ChannelCardWithDenomsToJSON(
  value?: ChannelCardWithDenoms | null
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    channel_id: value.channelId,
    card: CardToJSON(value.card),
    is_active: value.isActive,
    created_at: value.createdAt.toISOString(),
    updated_at: value.updatedAt.toISOString(),
    listing_order: value.listingOrder,
    begin_price: value.beginPrice,
    image: value.image,
    channel_denominations: (value.channelDenominations as Array<any>).map(
      ChannelDenominationToJSON
    ),
  };
}
